<template>
  <b-table v-if="policies" :items="policies" responsive="lg" :fields="policy_fields">
    <template v-slot:cell(rules)="data">
      <b-container fluid>
      <template v-for="r in data.item.rules">
        <FWMLv2RuleViz :rule="r" :key="r"/>
      </template>
      </b-container>
    </template>
    <template v-slot:cell(targets)="data">
      <ul>
        <li v-for="t in data.value" v-bind:key="t"><FWMLv2TargetViz :target="t"/></li>
      </ul>
    </template>
  </b-table>
  <p v-else class="text-center text-muted font-italic">{{$t('nws.no_policies')}}</p>
</template>

<script>

import FWMLv2RuleViz from '@/components/fwml/FWMLv2RuleViz.vue'
import FWMLv2TargetViz from '@/components/fwml/FWMLv2TargetViz.vue'

export default {
  name: 'FWMLv2PolicyViz',
  components: { FWMLv2TargetViz, FWMLv2RuleViz },
  props: {
    policies: {
      type: Array,
      required: true
    }
  },
  computed: {
    policy_fields() {
      return [
        {
          label: this.$t('system.name'),
          key: 'name'
        },
        {
          label: this.$t('nws.rules'),
          key: 'rules'
        },
        {
          label: this.$t('nws.targets'),
          key: 'targets'
        },
        {
          label: this.$t('system.description'),
          key: 'description'
        },
      ]
    }
  },
}
</script>
